var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12532_313954)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.26672 10.733L1.82359 9.46422C1.72865 9.42917 1.64673 9.36587 1.58888 9.28284C1.53102 9.19981 1.5 9.10104 1.5 8.99984C1.5 8.89864 1.53102 8.79987 1.58888 8.71684C1.64673 8.63381 1.72865 8.57051 1.82359 8.53547L5.26672 7.26672L6.53547 3.82359C6.57051 3.72865 6.63381 3.64673 6.71684 3.58888C6.79987 3.53102 6.89864 3.5 6.99984 3.5C7.10104 3.5 7.19981 3.53102 7.28284 3.58888C7.36587 3.64673 7.42917 3.72865 7.46422 3.82359L8.73297 7.26672L12.1761 8.53547C12.271 8.57051 12.3529 8.63381 12.4108 8.71684C12.4687 8.79987 12.4997 8.89864 12.4997 8.99984C12.4997 9.10104 12.4687 9.19981 12.4108 9.28284C12.3529 9.36587 12.271 9.42917 12.1761 9.46422L8.73297 10.733L7.46422 14.1761C7.42917 14.271 7.36587 14.3529 7.28284 14.4108C7.19981 14.4687 7.10104 14.4997 6.99984 14.4997C6.89864 14.4997 6.79987 14.4687 6.71684 14.4108C6.63381 14.3529 6.57051 14.271 6.53547 14.1761L5.26672 10.733Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 1V4",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 4.5V6.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.5 2.5H12.5",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 5.5H15",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12532_313954"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiIcon);
export default __webpack_public_path__ + "static/media/ai-icon.5eb5924f8fe786d7e40b6bdc76632f94.svg";
export { ForwardRef as ReactComponent };